import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=272c87d0&"
import script from "./desktop.vue?vue&type=script&lang=ts&"
export * from "./desktop.vue?vue&type=script&lang=ts&"
import style0 from "./desktop.vue?vue&type=style&index=0&id=272c87d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports